<section class="comparison-section section-depth-{{depth}}">
	@for (category of primaryCountry; track category; let i = $index) {
	<div class="row">
		<div class="col col-12 col-lg-3 mb-4 mb-lg-0">
			@if (category.type == 'CategoryItemConfig') {
			<span class="heading-{{depth}}">
				{{category.name}}
			</span>
			}
			@if (category.type !== 'CategoryItemConfig') {
			<span class="item-heading">
				{{category.name}}
			</span>
			}
			<hr class="hidden-lg-up">
		</div>
		<div class="col col-12 col-lg-9">
			<div class="row">
				<div class="col col-md-4">
					@if (category?.itemDetail?.value) {
					<div class="user-content" [innerHTML]="category?.itemDetail.value"></div>
					}
					@if (!category?.itemDetail?.value) {
					<div>-</div>
					}
				</div>
				<div class="col col-md-4">
					@if (getSecondaryCountryItemValue(category.id)) {
					<div class="user-content" [innerHTML]="getSecondaryCountryItemValue(category.id)"></div>
					}
					@if (!getSecondaryCountryItemValue(category.id)) {
					<div>-</div>
					}
				</div>
				<div class="col col-md-4">
					@if (getTertiaryCountryItemValue(category.id)) {
					<div class="user-content" [innerHTML]="getTertiaryCountryItemValue(category.id)"></div>
					}
					@if (!getTertiaryCountryItemValue(category.id)) {
					<div>-</div>
					}
				</div>
			</div>
		</div>
	</div>
	@if (!sectionHidden) {
	<div>
		<country-comparison-item [primaryCountry]="category?.children"
								 [secondaryCountry]="secondaryCountry"
								 [tertiaryCountry]="tertiaryCountry"
								 [depth]="depth+1">
		</country-comparison-item>
	</div>
	}
	}
</section>







